export type PurchaseTierFilterType = "premium" | "regular";

export type PredefinedFiltersType = Record<string, Record<string, {value: string, name: string}[]>>;

export const SORT_BY_PRICE_ASC = "price-asc";
export const SORT_BY_PRICE_DESC = "price-desc";
export const SORT_BY_THC_ASC = "thc-asc";
export const SORT_BY_THC_DESC = "thc-desc";
export type SortByType = null | typeof SORT_BY_PRICE_ASC | typeof SORT_BY_PRICE_DESC | typeof SORT_BY_THC_ASC | typeof SORT_BY_THC_DESC;


export type AdditionalData = {
  thc?: number,
  cbd?: number,
  genetic?: string | null,
  strain?: string | null,
  effects?: string[] | null,
  thc_unit?: "%" | "mg" | "ml" | null,
  cbd_unit?: "%" | "mg" | "ml" | null,
  type?: "flower" | "extract" | "vape" | "edible" | null,
  medical_attributes?: string[] | null,
  overrided_product_type?: string | null,
}

export type ChooseTreatmentProductItemType =  {
  product_item_id: number,
  quantity: number,
  price: number,
  shipping_fee: number,
  treatment_fee: number,
  service_fee: number,
  official_price: number,
  in_stock: boolean,
  express_stock: boolean,
  custom_quantity_title: string,
  available_stocks?: {stockCode: string, officialPrice: number}[],
  shipping_method_prices?: { default?: number; express?: number; self_pickup?: number },
}

export type ChooseTreatmentProductType = {
  product_id: number,
  treatment_fee: number,
  catalog_id: number
  dosage_str: string,
  title: string,
  product_settings?: { [key: string]: Array<string> }
  in_stock: boolean,
  items: ChooseTreatmentProductItemType[],
  quantity_type: string,
  minPricePerQuantity: number,
  // currently applies only to cannabis propreties
  additional_data?: AdditionalData,
  image?: {
    base_path: string,
    name: string
  } | null,
}

export interface CannabisLimitViolation {
  type: 'monthly_grams' | 'hourly_order' | 'daily_order';
  retryAfterHours: number | null;
  remainingGrams?: number;
}

export interface CannabisLimitsResult {
  isBlocked: boolean;
  violations: CannabisLimitViolation[];
  allowedCannabisGramsQuota: number;
  monthlyLimit: number;
}

// Distinct filter values across a whole catalog, from the search index aggregations. The filter
// menu is built from these rather than from the loaded page, which only ever reflects 50 products.
export type CTFacets = {
  genetic: string[];
  type: string[];
  effects: string[];
  medical_attributes: string[];
};
